import useOcapiSite from './useOcapiSite'
import {useMemo} from 'react'
import {isD2BCustomer} from '../utils/d2b-utils'
import {useCurrentCustomer} from './use-current-customer'

/**
 * Checks if d2b is enabled and current customer is d2b Customer
 *
 * @return {enabled} - isD2BCustomer
 *
 * */
export const useD2BCustomer = () => {
    const {data: customer} = useCurrentCustomer()
    const {d2bEnabled, taxationPolicy} = useOcapiSite()
    return useMemo(() => {
        const isd2bCustomer = isD2BCustomer(d2bEnabled, customer)
        return {
            enabled: isd2bCustomer,
            isCustomNetPriceEnabled: isd2bCustomer && taxationPolicy === 'gross'
        }
    }, [customer, d2bEnabled, taxationPolicy])
}
